import { z } from "zod";
/**
 * Markdown Block
 */
export const richTextBlockMarkdownContentDtoSchema = z.object({
    markdownMetric: z.string().nullable(),
    markdownImperial: z.string().nullable(),
});
export const richTextBlockMarkdownDtoSchema = z.object({
    kind: z.literal("markdown"),
    markdown: richTextBlockMarkdownContentDtoSchema.nullable(),
});
/**
 * Table Block
 */
export const richTextBlockTableContentColumnTypeDtoSchema = z.union([
    z.literal("number"),
    z.literal("string"),
    z.literal("date"),
    z.literal("datetime"),
]);
export const richTextBlockTableContentColumnAlignDtoSchema = z.union([
    z.literal("left"),
    z.literal("center"),
    z.literal("right"),
]);
export const richTextBlockTableContentColumnDtoSchema = z.object({
    title: z.string(),
    type: richTextBlockTableContentColumnTypeDtoSchema,
    valueKeyMetric: z.string(),
    valueKeyImperial: z.string().nullable(),
    unitMetric: z.string().nullable(),
    unitImperial: z.string().nullable(),
    minWidth: z.number().min(0).nullable(),
    align: richTextBlockTableContentColumnAlignDtoSchema.nullable(),
});
export const richTextBlockTableContentRowDtoSchema = z.record(z.string(), z.string().nullable());
export const richTextBlockTableContentDtoSchema = z.object({
    columns: z.array(richTextBlockTableContentColumnDtoSchema),
    rows: z.array(richTextBlockTableContentRowDtoSchema),
});
export const richTextBlockTableDtoSchema = z.object({
    kind: z.literal("table"),
    table: richTextBlockTableContentDtoSchema.nullable(),
});
/**
 * Rich Text Block
 */
export const richTextBlockDtoSchema = z.union([richTextBlockMarkdownDtoSchema, richTextBlockTableDtoSchema]);
//# sourceMappingURL=rich-text-block.schema.js.map